import React from 'react';
import Header from '../components/landing/Header';
import Hero from '../components/landing/Hero';
import Ecosystem from '../components/landing/Ecosystem';
import Stats from '../components/landing/Stats';
import Platform from '../components/landing/Platform';
import Features from '../components/landing/Features';
import HowItWorks from '../components/landing/HowItWorks';
import Testimonials from '../components/landing/Testimonials';
import CTA from '../components/landing/CTA';
import Footer from '../components/landing/Footer';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <Ecosystem />
        <Platform />
        <section id="features">
          <Features />
        </section>
        <Stats />
        <section id="how-it-works">
          <HowItWorks />
        </section>
        <section id="testimonials">
          <Testimonials />
        </section>
        <CTA />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
